import { render, staticRenderFns } from "./asignaturas_x_docente.vue?vue&type=template&id=43f0662a&scoped=true"
import script from "./asignaturas_x_docente.vue?vue&type=script&lang=js"
export * from "./asignaturas_x_docente.vue?vue&type=script&lang=js"
import style0 from "./asignaturas_x_docente.vue?vue&type=style&index=0&id=43f0662a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f0662a",
  null
  
)

export default component.exports